import React, { ChangeEvent, ReactElement, useRef, useState } from "react";
import { Button, Col, Form as BSForm, Row } from "react-bootstrap";
import { Form } from "./Form";
import { FormService } from "./FormService";

interface IParams {
	onCreate: (form: Form) => void;
}

export const FormCreateForm = (props: IParams): ReactElement => {
	const [form] = useState<Form>(new Form());
	const [submitting, setSubmitting] = useState(false);
	const nameRef = useRef<HTMLInputElement>(null);
	const formService = new FormService();

	const handleSubmit = async () => {
		if (!form.name.trim()) {
			nameRef.current?.focus();
			return;
		}
		setSubmitting(true);
		const newForm = await formService.create(form);
		setSubmitting(false);
		props.onCreate(newForm);
	};

	return (
		<>
			<h5 className="mb-3" style={{ fontWeight: 600 }}>
				<i className="fa fa-plus-circle" style={{ marginRight: 8, opacity: 0.6 }} />
				New Form
			</h5>
			<BSForm>
				<Row>
					<Col md={6}>
						<BSForm.Group>
							<BSForm.Label>Name</BSForm.Label>
							<BSForm.Control
								ref={nameRef}
								type="text"
								placeholder="e.g. Product Demo Request"
								onChange={(event: ChangeEvent<HTMLInputElement>) => {
									form.name = event.target.value;
								}}
							/>
						</BSForm.Group>
					</Col>
					<Col md={4}>
						<BSForm.Group>
							<BSForm.Label>Type</BSForm.Label>
							<BSForm.Control
								as="select"
								defaultValue="courseware"
								onChange={(event: ChangeEvent<HTMLInputElement>) => {
									form.type = event.target.value;
								}}
							>
								<option value="courseware">Courseware</option>
								<option value="elearning">eLearning</option>
								<option value="virtualcampus">Virtual Campus</option>
								<option value="dmi">DMI</option>
								<option value="gameo">Gameo</option>
								<option value="whitepaper">Whitepaper</option>
								<option value="generic">Generic</option>
							</BSForm.Control>
						</BSForm.Group>
					</Col>
					<Col md={2} className="d-flex align-items-end">
						<BSForm.Group className="w-100">
							<Button
								onClick={handleSubmit}
								disabled={submitting}
								className="w-100"
							>
								{submitting ? (
									<>
										<i className="fa fa-spinner fa-spin" /> Creating...
									</>
								) : (
									"Create"
								)}
							</Button>
						</BSForm.Group>
					</Col>
				</Row>
			</BSForm>
			<small className="text-muted">
				A unique GUID will be generated automatically.
			</small>
		</>
	);
};
